import React from 'react';
import srcHasPhoto from '../assets/has-photo.svg';
import Dialog from '../../../../../../reusables/Dialog';
import DialogExtraImage from '../../../../../../reusables/Dialog/extras/image';
import DialogExtraCaption from '../../../../../../reusables/Dialog/extras/caption';
import Link from '@/presentation/reusables/Link';

interface IProps {
  handlerClose: () => void;
  show: boolean;
  goToUrl: string;
}

const YouNotHavePhoto = ({ handlerClose, show, goToUrl }: IProps) => (
  <Dialog
    handlerClose={() => handlerClose()}
    handlerButtonA={() => handlerClose()}
    maxWidth="360px"
    show={show}
    zIndex={1000}
    textButtonA="Entendido"
  >
    <DialogExtraImage src={srcHasPhoto} alt="has-photo" />
    <DialogExtraCaption
      title="Todavía no has registrado tu foto"
      subtitle={
        <>
          Para las mujeres, se requiere el uso de blusa y sastre. Y en el caso
          de los varones es camisa, corbata y saco. Puedes hacerlo en el trámite
          de{' '}
          <Link
            linkType="internal"
            url={goToUrl}
            linkName="actualización de fotografía"
          />
        </>
      }
    />
  </Dialog>
);

export default YouNotHavePhoto;
